




import {Component, Watch, Prop, Vue} from 'vue-property-decorator';
import {DateTime} from "luxon";

@Component
export default class DatePicker extends Vue {
    @Prop({ type: String, required: true })
    private value!: string;
    @Prop({type: Boolean, default: false})
    private disabled!: boolean;

    private newValue: string = '';

    @Watch('newValue')
    private updateValue() {
        if (!this.newValue && this.value) {
            this.$emit('input', this.newValue);
        } else {
            const local = DateTime.fromISO(this.newValue);
            const newValue = DateTime.fromObject({ year: local.year, month: local.month, day: local.day, hour: 12, minute: 0, zone: 'America/Chicago' }).toISO();
            if (this.value !== newValue) {
                this.$emit('input', newValue);
            }
        }
    }

    @Watch('value')
     private valueProp() {
        this.newValue = this.value;
    }

    public created() {
       this.newValue = this.value;
    }
}
